<template>
  <div class="SaleLedger">
    <ATable
      ref="table"
      v-loading="loading"
      buttons-width="300px"
      max-height="650px"
      :data="filteredItems"
      :page-size="20"
      :disabled="disabled"
      :summaryFields="summaryFields"
      :summaryTitleColumnIndex="5"
      show-summary
      hide-button-insert
      border
      hide-pagination
      @selection-change="handleSelectionChange"
    >
      <div slot="search">
        <div class="inline">
          <div class="inline bold">매출일</div>
          <ADatePicker
            v-model="searchDate"
            class="inline ml-default"
            placeholder="날짜 선택"
            :disabled="disabled"
            @change="handleChangeDate"
          />
        </div>
        <div class="inline ml-default">
          <el-select
            v-model="contract_code"
            placeholder="수주번호"
            :disabled="disabled"
          >
            <el-option
              v-for="item in contractCodes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
      <el-table-column
        type="selection"
        label="선택"
        align="center"
        :width="$width.selection"
      />
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.index"
      />
      <el-table-column
        prop="sale_date"
        label="매출일"
        :width="$width.date"
        show-overflow-tooltip
      />
      <el-table-column
        prop="contract_code"
        label="수주번호"
        width="100"
        show-overflow-tooltip
      />
      <el-table-column
        prop="product_name"
        label="품목"
        width="150"
        show-overflow-tooltip
      />
      <el-table-column
        prop="size"
        :label="$t('lang.size')"
        width="100"
        show-overflow-tooltip
      />
      <el-table-column
        prop="pyung"
        label="평"
        width="80"
        show-overflow-tooltip
        :formatter="calcPyung"
      />
      <el-table-column
        prop="amount"
        label="수량"
        class-name="cell-number"
        :width="$width.amount"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.amount"
              @change="handleChangeCost(scope.row)"
            />
          </div>
          <div v-else>{{ util.addComma(scope.row.amount) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="unit_name"
        label="단위"
        :width="$width.unit_name"
      />
      <el-table-column
        prop="cost"
        label="단가"
        class-name="cell-number"
        :width="$width.price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId && (!showPyungProcessingCost || (showPyungProcessingCost && !isGlass(scope.row)))">
            <ANumberInput
              v-model="scope.row.cost"
              @change="handleChangeCost(scope.row)"
            />
          </div>
          <div v-else>{{ util.addComma(scope.row.cost) }}</div>
        </template>
      </el-table-column>


      <el-table-column
        v-if="showPyungProcessingCost"
        prop="pyung_cost"
        label="평단가"
        class-name="cell-number"
        :width="$width.price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId && isGlass(scope.row)">
            <ANumberInput
              v-model="scope.row.pyung_cost"
              @change="handleChangeCost(scope.row)"
            />
          </div>
          <div v-else>{{ util.addComma(scope.row.pyung_cost) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showPyungProcessingCost"
        prop="item_processing_cost"
        label="가공비"
        class-name="cell-number"
        :width="$width.price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId && isGlass(scope.row)">
            <ANumberInput
              v-model="scope.row.item_processing_cost"
              @change="handleChangeCost(scope.row)"
            />
          </div>
          <div v-else>{{ util.addComma(scope.row.item_processing_cost) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="supply_price"
        label="공급가액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="tax"
        label="세액"
        class-name="cell-number"
        :width="$width.price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.tax"
              @change="handleChangeTax(scope.row)"
            />
          </div>
          <div v-else>{{ util.addComma(scope.row.tax) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        label="금액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column prop="delivery_date" label="납기일" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ADatePicker
              v-model="scope.row.delivery_date"
              size="tiny"
              class="el-only-date-editor"
              :clearable="false"
            />
          </div>
          <div v-else>{{ scope.row.delivery_date }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="delivery_way_flag" label="출하방법" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ADeliveryWaySelector
              v-model="scope.row.delivery_way_flag"
              @change="handleChangeDeliveryWay(scope.row)"
            />
          </div>
          <div v-else>
            {{ resolveDeliveryWayFlag(scope.row.delivery_way_flag) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="zipcode" label="우편번호" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-input
              v-model="scope.row.zipcode"
              class="zipcode readonly"
              readonly
              style="width: 50px;"
            />&nbsp;
            <el-button
              icon="el-icon-search"
              @click="popupZipcode(handleCompleteZipcode)"
            />
          </div>
          <div v-else>{{ scope.row.zipcode }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="destination"
        label="도착지"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-input size="tiny" v-model="scope.row.destination" />
          </div>
          <div v-else>{{ scope.row.destination }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="field"
        label="현장"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-input size="tiny" v-model="scope.row.field" maxlength="100" />
          </div>
          <div v-else>{{ scope.row.field }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="비고"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-input size="tiny" v-model="scope.row.desc" maxlength="100" />
          </div>
          <div v-else>{{ scope.row.desc }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="charger" label="담당자" :width="$width.username">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-input size="tiny" v-model="scope.row.charger" maxlength="100" />
          </div>
          <div v-else>{{ scope.row.charger }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        v-if="has_grant_write"
        label="명령"
        width="115"
        fixed="right"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-button
              type="primary"
              size="mini"
              @click="handleClickUpdate(scope.row)"
              >저장</el-button
            >
            <el-button size="mini" @click="calcelEditing">취소</el-button>
          </div>
          <div v-else>
            <el-button size="mini" @click="handleClickModify(scope.row)"
              >수정</el-button
            >
          </div>
        </template>
      </el-table-column>
      <div slot="buttons">
        <el-button
          :disabled="disabled || !has_grant_write"
          @click="handleClickCreate"
          >수기 매출</el-button
        >
        <el-button
          type="danger"
          :disabled="selection.length < 1 || !has_grant_write"
          @click="handleClickDelete"
          >매출 취소</el-button
        >
      </div>
    </ATable>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="수기 매출"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened"
    >
      <SaleForm
        ref="form"
        v-if="dialog_visible"
        :customer="customer"
        @completed="handleCompleted"
      />
    </el-dialog>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { zipcode_search } from "@/common/mixins/zipcode_search";
import { company_info } from "@/common/mixins/company_info";
import SaleForm from "./SaleForm";

export default {
  name: "SaleLedger",
  mixins: [form_container, zipcode_search, company_info],
  components: { SaleForm },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false
      },
      title: this.$t("title.sale_ledger"),
      items: [{ value: "", label: "" }],
      summaryFields: ["cost", "item_processing_cost", "supply_price", "tax", "price"],
      contract_code: null,
      searchDate: this.util.getDate(),
      search_period: { value: "1m" },
      period: {},
      loading: false,
      selection: [],
      dialog_visible: false,
      editingItem: null,
      editingId: 0,
      change_code_flag: false,
    };
  },
  props: {
    customer: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    customer: function() {
      this.contract_code = null;
      this.change_code_flag = true;
      this.loadData();
    },
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    selectionIds() {
      if (this.selection.length < 1) {
        return [];
      }
      return this.selection.map((s) => s.id);
    },
    contractCodes() {
      if (this.items.length < 1) {
        return [];
      }
      let items = [];
      this.items.forEach((item) => {
        if (!item.contract_code) {
          return true;
        }
        let index = items.findIndex((e) => e.value === item.contract_code);
        if (index < 0) {
          items.push({ value: item.contract_code, label: item.contract_code });
        }
        if (this.change_code_flag) {
          this.contract_code = items[0].value;
          this.change_code_flag = false;
        }
      });
      items.splice(items.length, 0, { value: null, label: "수기매출" });
      return items;
    },
    filteredItems() {
      return this.items.filter(
        (item) => item.contract_code === this.contract_code
      );
    },
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadData() {
      if (!this.customer) {
        return;
      }
      if (!this.searchDate) {
        return;
      }
      this.loading = true;
      let period = {
        startDate: this.searchDate,
        endDate: this.searchDate,
      };
      this.api.listSaleCustomer(this.customer.id, period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    calcelEditing() {
      if (this.editingId < 1) {
        return;
      }
      let index = this.items.findIndex((i) => i.id === this.editingItem.id);
      if (index > -1) {
        this.items.splice(index, 1, this.editingItem);
      }
      this.editingItem = null;
      this.editingId = 0;
    },
    doDelete() {
      this.loading = true;
      let params = this.selectionIds;
      this.api.deleteSale(params).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
      });
    },
    resolveDeliveryWayFlag(value) {
      if (!value) {
        return "";
      }
      let flag = this.system.options.delivery_way_flag.find(
        (f) => f.value === value
      );
      return flag ? flag.label : "";
    },
    handleChangeDate(period) {
      this.period = period;
      this.contract_code = null;
      this.change_code_flag = true;
      this.items = [];
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickCreate() {
      this.dialog_visible = true;
    },
    handleClickDelete() {
      let messsage =
        "취소시 해당 수주의 모든 매출이 취소됩니다. 취소하시겠습니까?";
      this.util.confirm_delete(this, this.title, this.doDelete, messsage);
    },
    handleCompleted(result) {
      this.dialog_visible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
    handleClickModify(item) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing();
      }
      this.editingItem = Object.assign({}, item);
      this.editingId = item.id;
    },
    handleChangeCost(item) {
      if(this.showPyungProcessingCost && this.isGlass(item)){
        item.cost = this.calcPyung(item) * item.pyung_cost
        item.supply_price = item.cost * item.amount + item.item_processing_cost * item.amount
      }else{
        item.supply_price = item.cost * item.amount;
      }
      item.tax = Math.ceil(item.supply_price * 0.1);
      item.price = item.supply_price + item.tax;
    },
    handleChangeTax(item) {
      item.price = item.supply_price + item.tax;
    },
    handleClickUpdate(item) {
      this.loading = true;
      this.api.updateSale(item).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(
          this,
          this.title,
          this.$t("message.success_update")
        );
        this.loadData();
        this.calcelEditing();
      });
    },
    handleChangeDeliveryWay(item) {
      let info = this.util.getAddressByDeliveryWay(
        item.delivery_way_flag,
        this.customer
      );
      if (!info) {
        return;
      }
      item.zipcode = info.zipcode;
      item.destination = info.addr;
    },
    handleCompleteZipcode(zipcode, addr) {
      let item = this.items.find((item) => item.id === this.editingId);
      if (!item) {
        return;
      }
      item.zipcode = zipcode;
      item.destination = addr;
    },
    calcPyung(row) {
      let value = row.size;
      if (row.product_kind === "GLASS" && value) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map((x) => Number(x));
        const return_value =
          this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : return_value < 3 ? 3 : return_value;
      }
      return "";
    },
    isGlass(row) {
      return row.product_kind === 'GLASS'
    }
  },
};
</script>
